import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-feedback-fab',
  standalone: true,
  templateUrl: './feedback-fab.component.html',
  styleUrls: ['./feedback-fab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackFabComponent {
  disabled = input(false);
  showLabelOnHover = input(false);
  feedbackClick = output<void>();

  onClick(): void {
    if (!this.disabled()) {
      this.feedbackClick.emit();
    }
  }
}
